// An unavailable historical result is neither unfinished work nor proof of
// completion. Share this distinction between the agenda and the learning road.
export const isUnknownAssignmentSlot = (slot) => !!slot && !slot.na
  && (slot.status === 'unknown' || (slot.done !== true && slot.done !== false && slot.skipped !== true));

export const isOpenAssignmentSlot = (slot) => !!slot && !slot.na && slot.skipped !== true
  && slot.status !== 'unknown' && slot.done === false;

export function assignmentSlotSummary(assignment) {
  const slots = (assignment?.slots || []).filter((slot) => slot && !slot.na);
  const unknown = slots.filter(isUnknownAssignmentSlot);
  const known = slots.filter((slot) => !isUnknownAssignmentSlot(slot));
  return {
    slots, known, unknown,
    doneCount: known.filter((slot) => slot.done === true || slot.skipped === true).length,
    next: slots.find(isOpenAssignmentSlot) || null,
  };
}
